// ======================================================================
// 📁 File: src/modules/ppe/routes/PPERoutes.js
// ======================================================================

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import PPELayout from "../PPELayout";

// Dashboards & Orders
import PPEDashboard from "../pages/dashboard/PPEDashboard";
import OrdersListPage from "../pages/orders/OrdersListPage";
import OrderDetailPage from "../pages/orders/OrderDetailPage";
import CreateOrderPage from "../pages/orders/CreateOrderPage";

// Engineering Masters
import ProductFamilyListPage from "../pages/engineering/product-family/ProductFamilyListPage";
import ProductVariantListPage from "../pages/engineering/product-variant/ProductVariantListPage";
import EquipmentMasterPage from "../pages/engineering/equipment/EquipmentMasterPage";

import ProcessListPage from "../pages/process/ProcessListPage";
//import RoutingListPage from "../pages/routing/RoutingListPage";
import RoutingListPage from "../pages/engineering/routing/RoutingListPage";
import RoutingCreateOverlay from "../pages/engineering/routing/RoutingCreateOverlay";

import SKUAttributePage from "../pages/masters/sku-attributes/SKUAttributePage";

// BOQ Master
import BOQMasterList from "../pages/engineering/boq/BOQMasterList";
import BOQCreateOverlay from "../pages/engineering/boq/BOQCreateOverlay";

// Material Masters
import RawMaterialListPage from "../pages/material/raw-material/RawMaterialListPage";
import BoughtOutListPage from "../pages/material/boughtout/BoughtOutListPage";

//upload
import UploadFrameworkPage from "../pages/uploads/UploadFrameworkPage";

// ✅ Resources Masters (ADDED)
import MachineGroupListPage from "../pages/resources/machine-group/MachineGroupListPage";
import MachineListPage from "../pages/resources/machine/MachineListPage";
import ToolListPage from "../pages/resources/tool/ToolListPage";
import DrawingListPage from "../pages/engineering/drawing/DrawingListPage";
import SkillListPage from "../pages/resources/skill/SkillListPage"; // ✅ ADDED
import WorkerListPage from "../pages/resources/worker/WorkerListPage"; // ✅ ADD THIS

import ProductionPlanningDashboard from "../pages/planning/ProductionPlanningDashboard";

// ================= EXECUTION =================
import ProductionExecutionDashboard from "../pages/execution/ProductionExecutionDashboard";
import ExecutionPlanList from "../pages/execution/ExecutionPlanList";
import ExecutionOperationList from "../pages/execution/ExecutionOperationList";
// ADDED 2026-02-23 — Material Issue
import MaterialIssueListPage from "../pages/execution/material-issue/MaterialIssueListPage";

// ================= MES (SHOPFLOOR) =================
import ShopFloorDashboard from "../pages/execution/mes/dashboard/ShopFloorDashboard";

//========================Master=========================
import BusinessPartnerListPage from "../pages/masters/business_partner/BusinessPartnerListPage";

// ================= PROCUREMENT =================
import IndentListPage from "../pages/procurement/indent/list/IndentListPage";
import IndentDetailPage from "../pages/procurement/indent/view/IndentDetailPage";

// ================= PROCUREMENT LIFECYCLE REPORT =================
import LifecycleReportPage from "../pages/reports/lifecycle/LifecycleReportPage";

// ================= PURCHASE REQUEST =================

import PurchaseRequestListPage from "../pages/procurement/purchaseRequest/list/PurchaseRequestListPage";
import PurchaseRequestDetailPage from "../pages/procurement/purchaseRequest/view/PurchaseRequestViewDrawer";

// ================= RFQ MODULE =================
import RFQList from "../pages/procurement/rfq/view/RFQList";
import RFQCompare from "../pages/procurement/rfq/view/RFQCompare";
import VendorQuoteEntry from "../pages/procurement/rfq/view/VendorQuoteEntry";
import RFQQuoteEntryInternal from "../pages/procurement/rfq/quoteEntry/RFQQuoteEntryInternal";

import RFQQuoteEntryPage from "../pages/procurement/rfq/view/RFQQuoteEntryPage";

// ================= PURCHASE ORDER =================
import POList from "../pages/procurement/purchaseOrder/POList";
import PurchaseOrderPrint  from "../pages/procurement/purchaseOrder/PurchaseOrderPrint";

// ================= GRN MODULE =================
import GRNListPage from "../pages/procurement/grn/list/GRNListPage";
import GRNDetail from "../pages/procurement/grn/view/GRNDetail";

// ================= PURCHASE RETURN MODULE =================
import PurchaseReturnListPage from "../pages/procurement/purchase-return/list/PurchaseReturnListPage";
import PurchaseReturnDetail from "../pages/procurement/purchase-return/view/PurchaseReturnDetail";

//====================PURCHSE INVOICE=============================
import PurchaseInvoiceDetail
  from "../pages/procurement/purchaseInvoice/view/PurchaseInvoiceDetail";

  import PurchaseInvoiceList
  from "../pages/procurement/purchaseInvoice/list/PurchaseInvoiceList";

  import MyApprovalsPage from "../approval/pages/MyApprovalsPage";

// ================= PROCUREMENT DASHBOARD =================
import ProcurementDashboard from
"../pages/procurement/dashboard/ProcurementDashboard";


// ================= FMS MODULE =================
import FmsRoutes from "../fms/routes/FmsRoutes";

// ================= QA MODULE =================
import QARoutes from "../pages/quality/incoming/QARoutes";

// ================= INVENTORY REPORTS =================
import CurrentStockPage from
"../pages/inventory/reports/current-stock/CurrentStockPage";
// ================= INVENTORY REPORTS =================
import InventoryValuationPage from
"../pages/inventory/reports/inventory-valuation/InventoryValuationPage";

import StockRegisterPage from
"../pages/inventory/reports/stock-register/StockRegisterPage";

import InventoryLedgerPage from
"../pages/inventory/reports/inventory-ledger/InventoryLedgerPage";

import ItemLedgerPage from
"../pages/inventory/reports/item-ledger/ItemLedgerPage";

import RawMaterialMasterPage from
  "../pages/inventory/reports/raw-material-master/RawMaterialMasterPage";

// ================= TRANSPORT MODULE =================
import TransportRoutes from "../transport/routes/TransportRoutes";

import ProcurementLifecycleReport from
  "../pages/reports/procurement_lifecycle/ProcurementLifecycleReport";


export default function PPERoutes() {
  return (
    <PPELayout>
      <Routes>

        {/* Default */}
        <Route path="/" element={<Navigate to="dashboard" replace />} />

        {/* Dashboard 
        <Route path="dashboard" element={<PPEDashboard />} />
        */}  
        <Route path="dashboard/*" element={<PPEDashboard />} />

        {/* ================= PLANNING ================= */}
          <Route
            path="planning"
            element={<ProductionPlanningDashboard />}
          />

        {/* Orders */}
        <Route path="orders" element={<OrdersListPage />} />
        <Route path="orders/create" element={<CreateOrderPage />} />
        <Route path="orders/:orderId" element={<OrderDetailPage />} />

        {/* ================= EXECUTION ================= */}
        <Route
          path="execution"
          element={<ProductionExecutionDashboard />}
        />

        {/* ADDED 2026-02-23 — Material Issue */}
        <Route
          path="execution/material-issue"
          element={<MaterialIssueListPage />}
        />

        <Route
          path="execution/plans/:planId"
          element={<ExecutionOperationList />}
        />

        <Route
          path="mes"
          element={<ShopFloorDashboard />}
        />

        <Route
            path="uploads"
            element={<UploadFrameworkPage />}
        />

        {/* ================= ENGINEERING MASTERS ================= */}
        <Route
          path="engineering/masters/product-family"
          element={<ProductFamilyListPage />}
        />
        <Route
          path="engineering/masters/product-variants"
          element={<ProductVariantListPage />}
        />
        <Route
          path="engineering/masters/equipment"
          element={<EquipmentMasterPage />}
        />
        
        <Route
          path="engineering/masters/drawing"
          element={<DrawingListPage />}
        />
        <Route
          path="engineering/masters/process"
          element={<ProcessListPage />}
        />
        <Route path="routing" element={<RoutingListPage />} />
        <Route path="routing/create" element={<RoutingCreateOverlay />} />
        <Route path="routing/edit/:routingId" element={<RoutingCreateOverlay />}/>
        <Route path="routing/view/:routingId" element={<RoutingCreateOverlay />} />

        {/* ================= BOQ MASTER ================= */}

        <Route
          path="engineering/boq"
          element={<BOQMasterList />}
        />

        <Route
          path="engineering/boq/create"
          element={<BOQCreateOverlay />}
        />

        <Route
          path="engineering/boq/edit/:boqId"
          element={<BOQCreateOverlay />}
        />

        <Route
          path="engineering/boq/view/:boqId"
          element={<BOQCreateOverlay />}
        />




        {/* ================= MATERIAL MASTERS ================= */}
        <Route
          path="material/masters/raw-material"
          element={<RawMaterialListPage />}
        />
        <Route
          path="material/masters/boughtout"
          element={<BoughtOutListPage />}
        />

        {/* ================= RESOURCES MASTERS (NEW) ================= */}
        <Route
          path="resources/masters/machine-group"
          element={<MachineGroupListPage />}
        />
        
        <Route
          path="resources/masters/machine"
          element={<MachineListPage />}
        />
        <Route
          path="resources/masters/tool"
          element={<ToolListPage />}
        />
         <Route
          path="resources/masters/skill"
          element={<SkillListPage />}
        />
         <Route
          path="resources/masters/worker"
          element={<WorkerListPage />}   
        />


        {/* ================= MASTERS ================= */}
        <Route
          path="masters/business-partner"
          element={<BusinessPartnerListPage />}
        />
        <Route
          path="masters/sku-attributes"
          element={<SKUAttributePage />}
        />

        {/* ================= PROCUREMENT ================= */}

          {/* ================= PROCUREMENT DASHBOARD ================= */}
            <Route
              path="procurement"
              element={<ProcurementDashboard />}
            />

          <Route
            path="procurement/indent"
            element={<IndentListPage />}
          />

          <Route
            path="procurement/indent/create"
            element={<IndentListPage />}
          />

          <Route
            path="procurement/indent/:id"
            element={<IndentDetailPage />}
          />

          {/* ================= PURCHASE REQUEST ================= */}

          <Route
            path="procurement/purchase-request"
            element={<PurchaseRequestListPage />}
          />

          <Route
            path="procurement/purchase-request/:id"
            element={<PurchaseRequestDetailPage />}
          />

          {/* ================= RFQ ================= */}

          <Route
            path="procurement/rfq"
            element={<RFQList />}
          />

          <Route
            path="procurement/rfq/compare/:rfqId"
            element={<RFQCompare />}
          />

          <Route
            path="procurement/rfq/quote/:rfqId/:vendorId"
            element={<RFQQuoteEntryPage />}
          />

          <Route
            path="procurement/rfq/quote-entry"
            element={<RFQQuoteEntryInternal />}
          />
          {/* ================= PURCHASE ORDER ================= */}

          <Route
            path="procurement/purchase-order"
            element={<POList />}
          />
          <Route
            path="procurement/my-approvals"
            element={<MyApprovalsPage />}
          />
          <Route
            path="procurement/purchase-order/print/:id"
            element={<PurchaseOrderPrint />}
          />
          
          {/* ================= GRN MODULE ================= */}

            <Route
              path="procurement/grn"
              element={<GRNListPage />}
            />

            <Route
              path="procurement/grn/:id"
              element={<GRNDetail />}
            />

            {/* ================= PURCHASE RETURN MODULE ================= */}

            <Route
              path="procurement/purchase-return"
              element={<PurchaseReturnListPage />}
            />

            <Route
              path="procurement/purchase-return/:id"
              element={<PurchaseReturnDetail />}
            />
            {/* ================= PURCHASE INVOICE MODULE ================= */}
            <Route
              path="/procurement/purchase-invoice"
              element={<PurchaseInvoiceList />}
            />

            <Route
              path="/procurement/purchase-invoice/:id"
              element={<PurchaseInvoiceDetail />}
            />

            {/* ================= FOLLOWUP MANAGEMENT SYSTEM ================= */}

            {/* ================= QA MANAGEMENT SYSTEM ================= */}
            <Route path="fms/*" element={<FmsRoutes />} />

            <Route path="/quality/*" element={<QARoutes />} />

            {/* ================= TRANSPORT MANAGEMENT ================= */}
            <Route path="transport/*" element={<TransportRoutes />} />

                    {/* ================= INVENTORY ================= */}

              <Route
                path="inventory/reports/current-stock"
                element={<CurrentStockPage />}
              />
              <Route
                path="inventory/reports/valuation"
                element={<InventoryValuationPage />}
              />

              <Route
                path="inventory/reports/stock-register"
                element={<StockRegisterPage />}
              />

              <Route
                path="inventory/reports/inventory-ledger"
                element={<InventoryLedgerPage />}
              />

              <Route
                path="inventory/reports/item-ledger"
                element={<ItemLedgerPage />}
              />

              <Route
                path="inventory/reports/raw-material-master"
                element={<RawMaterialMasterPage />}
              />
              {/* ================= LIFECYCLE REPORT ================= */}

              <Route
                path="reports/lifecycle"
                element={<LifecycleReportPage />}
              />        

              {/* ================= PROCUREMENT LIFECYCLE REPORT ================= */}

              <Route
                path="reports/procurement-lifecycle"
                element={<ProcurementLifecycleReport />}
              />
                      
        {/* Fallback */}
        <Route path="*" element={<Navigate to="dashboard" replace />} />

      </Routes>
    </PPELayout>
  );
}
